import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Toaster } from 'sonner';
import { DocumentUpload } from './components/DocumentUpload';
import { FieldExtraction } from './components/FieldExtraction';
import { ProgressStepper } from './components/ProgressStepper';
import { Completion } from './components/Completion';
import { useScreenInit } from './useScreenInit.js';
type Screen = 'upload' | 'review' | 'done';
export function App() {
  const screenInit = useScreenInit();
  const initialScreen: Screen = screenInit?.screen ?? 'upload';
  const [currentScreen, setCurrentScreen] = useState<Screen>(initialScreen);
  const [uploadedFile, setUploadedFile] = useState<File | null>(initialScreen === 'review' || initialScreen === 'done' ? new File([''], 'sample-document.pdf') : null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [savedFieldCount, setSavedFieldCount] = useState(initialScreen === 'done' ? 38 : 0);
  const handleUpload = (file: File) => {
    setIsProcessing(true);
    setUploadedFile(file);
    // Simulate processing delay
    setTimeout(() => {
      setIsProcessing(false);
      setCurrentScreen('review');
    }, 1500);
  };
  const handleBack = () => {
    setCurrentScreen('upload');
    setUploadedFile(null);
  };
  const handleSave = (fieldCount: number) => {
    setSavedFieldCount(fieldCount);
    setCurrentScreen('done');
  };
  const handleStartOver = () => {
    setCurrentScreen('upload');
    setUploadedFile(null);
    setSavedFieldCount(0);
  };
  const steps = [{
    label: 'Upload',
    status: currentScreen === 'upload' ? 'current' : 'completed'
  }, {
    label: 'Review',
    status: currentScreen === 'review' ? 'current' : currentScreen === 'done' ? 'completed' : 'upcoming'
  }, {
    label: 'Done',
    status: currentScreen === 'done' ? 'current' : 'upcoming'
  }] as const;
  return <div className="min-h-screen w-full bg-gray-50 py-12 px-4" data-id="element-0">
      <Toaster position="top-right" richColors data-id="element-1" />

      <ProgressStepper steps={steps} data-id="element-2" />

      <AnimatePresence mode="wait" data-id="element-3">
        {currentScreen === 'upload' && <DocumentUpload key="upload" onUpload={handleUpload} isProcessing={isProcessing} data-id="element-4" />}
        {currentScreen === 'review' && uploadedFile && <FieldExtraction key="review" fileName={uploadedFile.name} onBack={handleBack} onSave={handleSave} data-id="element-5" />}
        {currentScreen === 'done' && uploadedFile && <Completion key="done" fileName={uploadedFile.name} fieldCount={savedFieldCount} onStartOver={handleStartOver} data-id="element-6" />}
      </AnimatePresence>
    </div>;
}